import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";

export const SupporterBadgeCheers = ({ token, name }) => {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState("");
  const [params] = useSearchParams();
  const focus = params.get("cheer");

  useEffect(() => {
    api.get(`/supporters/view/${token}/badges`).then((r) => {
      setList(r.data);
      if (focus) setTimeout(() => document.getElementById("badges")?.scrollIntoView({ behavior: "smooth", block: "center" }), 300);
    }).catch((e) => logError("Shared badges failed:", e));
  }, [token, focus]);

  const cheer = async (id) => {
    setBusy(id);
    try {
      await api.post(`/supporters/view/${token}/badges/${id}/cheer`);
      setList((l) => l.map((b) => (b.id === id ? { ...b, cheered: true } : b)));
      toast.success(`Cheer sent to ${name} 🎉`);
    } catch (e) { toast.error(errMsg(e, "Could not send cheer")); } finally { setBusy(""); }
  };

  if (!list?.length) return null;
  return (
    <div id="badges" className="mm-card p-5" data-testid="supporter-badge-cheers">
      <div className="font-semibold">🎉 {name} shared a win with you</div>
      <div className="space-y-2 mt-3">
        {list.map((b) => (
          <div key={b.id} className={`mm-soft p-3 flex items-center gap-3 ${focus === b.id ? "ring-2 ring-mm-primary" : ""}`} data-testid={`supporter-badge-${b.id}`}>
            <span className="text-3xl">{b.icon}</span>
            <div className="flex-1 min-w-0"><div className="font-semibold text-sm">{b.badge_name}</div><div className="text-xs text-mm-muted truncate">{b.subtitle}</div></div>
            {b.cheered ? <span className="text-xs font-semibold text-mm-primary" data-testid={`supporter-badge-cheered-${b.id}`}>Cheered 🎉</span> : (
              <button className="mm-btn !py-2 !px-3 text-sm shrink-0 inline-flex items-center gap-1.5" disabled={busy === b.id} onClick={() => cheer(b.id)} data-testid={`supporter-badge-cheer-${b.id}`}>
                {busy === b.id && <Loader2 size={14} className="animate-spin" />} So proud of you! 🎉
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
